import React from 'react';
import "./nav.css"
import { AiOutlineHome } from 'react-icons/ai'
import { AiOutlineUser } from 'react-icons/ai'
import { AiFillBook } from 'react-icons/ai'
import { RiServiceLine } from 'react-icons/ri'
import { BiMessageDetail } from 'react-icons/bi'
import { SiCodeproject } from 'react-icons/si'
import {FiDownload} from 'react-icons/fi'
import { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import resume from '../../outerComponents/Pritam_Halder.pdf'
const Nav = () => {
  const [activeNav, setActiveNav] = useState("#")
  return (
    <nav id="nav-menu">
      <Tooltip title={<h2 className='toolTip'>Home</h2>} placement="top" arrow>
        <a href="#"class='nav-link home' className={activeNav === '#' ? 'active' : ''}><AiOutlineHome color='#01be96' /></a>
      </Tooltip>
      <Tooltip title={<h2 className='toolTip'>About</h2>} placement="top" arrow>
        <a class="nav-link about"  href="#about" className={activeNav === '#about' ? 'active' : ''}><AiOutlineUser /></a>
      </Tooltip>
      <Tooltip title={<h2 className='toolTip'>Skills</h2>} placement="top" arrow>
        <a href="#skills" class="nav-link skills" className={activeNav === '#skills' ? 'active' : ''}><AiFillBook /></a>
      </Tooltip>
      {/* <Tooltip title={<h2 className='toolTip'>Services</h2>} placement="top" arrow>
        <a href="#services" className={activeNav === '#services' ? 'active' : ''}><RiServiceLine /></a>
      </Tooltip> */}
      <Tooltip title={<h2 className='toolTip'>Projects</h2>} placement="top" arrow>
        <a class="nav-link projects" href="#projects" className={activeNav === '#projects' ? 'active' : ''}><SiCodeproject /></a>
      </Tooltip>
      <Tooltip title={<h2 className='toolTip'>Contacts</h2>} placement="top" arrow>
        <a class="nav-link contact" href="#contact" className={activeNav === '#contact' ? 'active' : ''}><BiMessageDetail /></a>
      </Tooltip>
      <Tooltip title={<h2 className='toolTip'>Resume</h2>} placement="top" arrow>
        <a href={resume} id="resume-button-1" target='_blank' download="Pritam-Halder-Resume" onClick={() =>
  window.open(
    "https://drive.google.com/file/d/1DLS0HqF4MBcsZOehqQHw7tvzjIGcAfl1/view?usp=sharing"
  )} className={activeNav === {resume} ? 'active' : ''}><FiDownload /></a>
      </Tooltip>
    </nav>
  );
}

export default Nav;
